module.exports = __webpack_public_path__ + "static/media/university-solid.196fe4d6.svg";